#import "./VariantFragment.gql"
#import "./productOptionSwatchesFragment.gql"
#import "./productBadgesFragment.gql"
#import "./productFlagsFragment.gql"
#import "./productCardHeaderFragment.gql"
#import "./productProductCardUspFragment.gql"
#import "./productDigitalProductTypeFragment.gql"
#import "./productComparisonFragment.gql"

fragment ProductCardFragment on Product {
  handle
  id
  productType
  availableForSale
  title
  tags
  options {
    name
    values
  }
  priceRange {
    minVariantPrice {
      amount
      currencyCode
    }
    maxVariantPrice {
      amount
      currencyCode
    }
  }
  variants(first: 99) {
    edges {
      node {
        ...VariantFragment
      }
    }
  }
  ...productOptionSwatchesFragment
  ...productBadgesFragment
  ...productFlagsFragment
  ...productCardHeaderFragment
  ...productProductCardUspFragment
  ...productDigitalProductTypeFragment
  ...productComparisonFragment
}
